import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../../data/entitlement/site/initialState.site.data';

const SiteSlice = createSlice({
  name: 'site',
  initialState,
  reducers: {
    setDisplayType: (state, action) => {
      state.displayType = action?.payload;
    },
    setSearchParams: (state, action) => {
      state.searchParams[action?.payload?.key] = action?.payload?.value;
    },
    setSearchResult: (state, action) => {
      state.searchResult = action?.payload;
    },
    setSelectedSite: (state, action) => {
      state.selectedSite = action?.payload;
    },
    handleReset: () => {
      return initialState;
    },
    resetData: (state) => {
      state.selectedSite = initialState.siteDetails;
      state.customerDetails = initialState.customerDetails;
    },
    setCustomerDetails: (state, action) => {
      state.customerDetails = action?.payload;
    },
    setSiteDetails: (state, action) => {
      state.siteDetails = action?.payload;
      state.siteDetailsCopy = action?.payload;
      if (state.siteDetails['contractZonePricingOption'] === null) {
        if (state.siteDetails['zoneId'] !== null) {
          let siteOptionId = state.siteDetails['zoneId'];
          state.oldSiteOption = siteOptionId;
        }
      } else {
        if (state.siteDetails['contractZonePricingOption'] !== null) {
          let siteOptionId = state.siteDetails['contractZonePricingOption'];
          state.oldSiteOption = siteOptionId;
        }
      }
    },
    updateSiteDetails: (state, action) => {
      if (
        action?.payload?.key === 'contractZonePricingOption' &&
        action?.payload?.value !== null
      ) {
        if (Number(state.oldSiteOption) !== Number(action?.payload?.value)) {
          //state.newSiteOption = action?.payload?.value;
          state.isSiteOptionChanged = true;
        } else {
          state.isSiteOptionChanged = false;
        }
      }

      state.siteDetails[action?.payload?.key] = action?.payload?.value;
    },
    updateSiteCopy: (state, action) => {
      state.siteDetailsCopy = action?.payload;
      if (state.siteDetailsCopy['contractZonePricingOption'] === null) {
        if (state.siteDetailsCopy['zoneId'] !== null) {
          let siteOptionId = state.siteDetailsCopy['zoneId'];
          state.oldSiteOption = siteOptionId;
        }
      } else {
        if (state.siteDetailsCopy['contractZonePricingOption'] !== null) {
          let siteOptionId = state.siteDetailsCopy['contractZonePricingOption'];
          state.oldSiteOption = siteOptionId;
        }
      }
    },
    resetValues: (state) => {
      state.searchParams = initialState.searchParams;
      state.searchResult = initialState.searchResult;
      state.selectedSite = initialState.selectedSite;
    },
    setPayloadCustId: (state, action) => {
      state.payloadCustId = action?.payload;
    },
    setSiteAccountDetailData: (state, action) => {
      state.siteAccountDetailData = null;
      state.siteAccountDetailData = action?.payload;
    },
    setBack: (state, action) => {
      state.back = action?.payload;
    },
    setLocalSearchText: (state, action) => {
      state.localSearchText = action?.payload;
    },
    setFastSite: (state, action) => {
      state.fastSite = action?.payload;
    },
    setLocalSelectedComp: (state, action) => {
      state.localSelectedComp = action?.payload;
    },
    siteDataSaved: (state, action) => {
      state.siteDataSavedFlag = action?.payload;
    },
    setSiteOptionChanged: (state, action) => {
      state.isSiteOptionChanged = action?.payload || initialState.isSiteOptionChanged;
    },
  },
});

export const {
  setDisplayType,
  setSearchParams,
  setSearchResult,
  setSelectedSite,
  setSiteDetails,
  updateSiteCopy,
  updateSiteDetails,
  resetValues,
  setPayloadCustId,
  setSiteAccountDetailData,
  setBack,
  setLocalSearchText,
  setFastSite,
  setLocalSelectedComp,
  handleReset,
  resetData,
  setCustomerDetails,
  siteDataSaved,
  setSiteOptionChanged,
} = SiteSlice.actions;
export default SiteSlice.reducer;
